<template>
	<div class="default-input" :class="{'default-input--error' : errors.length}">
		<label class="default-input__label" v-if="label">{{ label }}</label>
		<div class="default-input__wrapper">
			<div class="default-input__choice">
				<button class="btn btn--border" :class="{'btn--color': value}" @click="value = true">Да</button>
				<button class="btn btn--border" :class="{'btn--color': !value}" @click="value = false">Нет</button>
			</div>
		</div>
		<ul v-if="errors.length" class="default-input__errors">
			<li>{{ errors[0].$message }}</li>
		</ul>
	</div>
</template>

<script>

export default {
	name: "InputChoice",
	emits:['update:modelValue'],
	props: {
		modelValue: {
			type: Boolean,
			default: true
		},
		label: {
			type: String,
			default: ''
		},

		disabled: {
			type: Boolean,
			default: false
		},

		errors: {
			type: Array,
			default: () => []
		},

	},

	data() {
		return {
			value: this.modelValue
		}
	},

	watch: {
		value() {
			this.$emit('update:modelValue', this.value)
		}
	},
}
</script>


